import React, { FC } from 'react';
import MapPolygon from 'js/components/MapObjects/MapPolygon';

interface Coordinate {
  lat: number;
  lng: number;
}

interface PolygonData {
  path: Coordinate[];
  valid?: boolean;
}

interface DrawnPolygonsProps {
  map: google.maps.Map;
  polygons: PolygonData[];
  polygonVisible: boolean;
  selectedMarker?: google.maps.Marker | null;
  onInsert: (polygonIndex: number, coordinate: Coordinate) => void;
  onMove: (polygonIndex: number, coordinate: Coordinate, vertexIndex?: number) => void;
  setIsPolygonValid: (polygonIndex: number, isValid: boolean) => void;
  setSelectedMarker: (marker: google.maps.Marker | null) => void;
}

// ----------------------
// Component
// ----------------------

const DrawnPolygons: FC<DrawnPolygonsProps> = ({
  map,
  polygons,
  polygonVisible,
  selectedMarker,
  onInsert,
  onMove,
  setIsPolygonValid,
  setSelectedMarker,
}) => {
  if (!polygonVisible) return null;

  return (
    <>
      {polygons
        .filter((p) => Array.isArray(p.path))
        .map((p, polygonIndex) => (
          <MapPolygon
            key={`pdc_${polygonIndex}`}
            coordinates={p.path}
            map={map}
            strokeColor="white"
            strokeWeight={4}
            editable
            fillColor="#aaaaaa"
            fillOpacity={0.2}
            onInsert={onInsert}
            onMove={onMove}
            isValid={p.valid}
            setIsPolygonValid={setIsPolygonValid}
            selectedMarker={selectedMarker}
            setSelectedMarker={setSelectedMarker}
            pindex={polygonIndex}
          />
        ))}
    </>
  );
};

export default DrawnPolygons;
